var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 19.9999L20.0002 13.3333M20.0002 13.3333L13.3335 19.9999M20.0002 13.3333V26.6666M36.6668 19.9999C36.6668 29.2047 29.2049 36.6666 20.0002 36.6666C10.7954 36.6666 3.3335 29.2047 3.3335 19.9999C3.3335 10.7952 10.7954 3.33325 20.0002 3.33325C29.2049 3.33325 36.6668 10.7952 36.6668 19.9999Z",
    stroke: "#0BCE63",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBuild);
export default __webpack_public_path__ + "static/media/success-build.56ad5e6178c5010576279449a425af76.svg";
export { ForwardRef as ReactComponent };